var _path, _g, _circle, _circle2, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgAdv2 = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_372_16128",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 3,
    width: 46,
    height: 42
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 6V41C1 43.2091 2.79086 45 5 45L12.5 45H42.5H43C45.2091 45 47 43.2091 47 41V24.1696C47 15.6636 42 10 34.9839 10V6C34.9839 4.34315 33.6408 3 31.9839 3H4C2.34315 3 1 4.34315 1 6Z",
    fill: "url(#paint0_linear_372_16128)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_372_16128)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 6V41C1 43.2091 2.79086 45 5 45L12.5 45H42.5H43C45.2091 45 47 43.2091 47 41V24.1696C47 15.6636 42 10 34.9839 10V6C34.9839 4.34315 33.6408 3 31.9839 3H4C2.34315 3 1 4.34315 1 6Z",
    fill: "url(#paint1_linear_372_16128)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 3H35V32C35 33.6569 33.6569 35 32 35H1V3Z",
    fill: "url(#paint2_linear_372_16128)"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 38.5,
    cy: 42.5,
    r: 4.5,
    fill: "#E5E4EC"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 42.5,
    r: 4.5,
    fill: "#E5E4EC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7253 26.7145L15.7254 26.7145L28.3624 14.5717C29.2125 13.7548 29.2125 12.4133 28.3624 11.5965C27.5348 10.8012 26.2088 10.8012 25.3812 11.5964L15.0201 21.5523L10.6155 17.3875C9.78763 16.5955 8.46411 16.5965 7.63758 17.3907L8.33044 18.1118L7.63758 17.3907C6.78747 18.2076 6.78747 19.5491 7.63758 20.366L7.642 20.3702L14.3302 26.7187C14.3302 26.7187 14.3303 26.7187 14.3303 26.7187C14.7218 27.0904 15.3362 27.0883 15.7253 26.7145Z",
    stroke: "#F44519",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_372_16128",
    x1: 7.81481,
    y1: 9.5625,
    x2: 41.4452,
    y2: 53.2168,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#928BB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5E4EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_372_16128",
    x1: 7.81481,
    y1: 9.5625,
    x2: 41.4452,
    y2: 53.2168,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#928BB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5E4EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_372_16128",
    x1: 2,
    y1: 3,
    x2: 32,
    y2: 35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D5D3E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5E4EC"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAdv2);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/adv2.747a375b1a9a70e743719bfe6831f63d.svg";